import React, { useState } from "react";
import { Button } from "antd";
import styled from "styled-components";
import PolicyConfigForm from "components/widgets/forms/setup/PolicyConfigForm";
import BasicDetails from "components/setup/BasicDetails";
import { fetch_product_details } from "services/apiSrv";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import Loader from "components/widgets/loader";

// Styled Components
const Title = styled.h2`
  font-size: 20px;
  margin-bottom: 12px;
  color: #555;
`;

const Section = styled.div`
  margin-bottom: 48px;
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  max-height: 60vh;
  overflow-y: auto;
  margin-bottom: 32px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 8px rgb(0 0 0 / 0.1);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    font-size: 14px;
  }

  th {
    background: #f4f4f4;
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 10;
  }
`;

export default function PolicyConfigPage() {
  const { id: productSystemRef } = useParams();

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["productDetails", productSystemRef],
    queryFn: () => fetch_product_details(productSystemRef),
    enabled: !!productSystemRef,
    retry: 2,
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <p>Error fetching product details: {error?.message || "Something went wrong"}</p>;
  }

  if (!data?.data) {
    return <p>No product data available.</p>;
  }

  const { productPolicyConfig } = data.data[0];

  return (
    <div>
      {/* Available Products */}
      <BasicDetails />

      {/* Policy Configuration Form */}
      <Section>
        <Title>Add Policy Configuration</Title>
        <PolicyConfigForm refetchProductDetails={refetch} />
      </Section>

      {/* Policy Configuration Details */}
      <Section>
        <Title>Policy Configuration Details</Title>
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th>Property</th>
                <th>Value</th>
              </tr>
            </thead>
            {productPolicyConfig && (
            <tbody>
              <tr>
                <td>Auto Renewal Notification</td>
                <td>{productPolicyConfig?.autoRenewalNotification || "N/A"} days</td>
              </tr>
              <tr>
                <td>Covernote Issuance</td>
                <td>{productPolicyConfig?.covernoteIssuance || "N/A"}</td>
              </tr>
              <tr>
                <td>Covernote Issuance Template</td>
                <td>{productPolicyConfig?.covernoteIssuanceTemplate || "N/A"}</td>
              </tr>
              <tr>
                <td>Valuation Required</td>
                <td>{productPolicyConfig?.isValuationRequired ? "Yes" : "No"}</td>
              </tr>
              <tr>
                <td>Valuation Template Reference</td>
                <td>{productPolicyConfig?.valuationTemplateRef || "N/A"}</td>
              </tr>
            </tbody>
            )}

          </Table>
        </TableWrapper>
      </Section>
    </div>
  );
}